import { createFileRoute, Outlet, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/hooks/use-auth";
import { BruloHeader } from "@/components/brulo-header";

export const Route = createFileRoute("/_authenticated")({
  component: AuthLayout,
});

function AuthLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Cargando...
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" />;
  return (
    <div className="min-h-screen brulo-grain">
      <BruloHeader />
      <Outlet />
    </div>
  );
}
